import * as EpisodeService from "@/services/EpisodeService"
import { notificationError } from "@/common/helpers/notifications.helper"

const resolveIsAiPodcast = (params, rootGetters) => {
  if (typeof params.isAiPodcast === "boolean") return params.isAiPodcast
  return !!rootGetters["Podcast/isAiPodcast"]
}

export const getEpisodes = async ({ commit, rootGetters }, { podcastKey, params, isStale, silent = false }) => {
  try {
    const isAiPodcast = resolveIsAiPodcast(params, rootGetters)
    const result = await EpisodeService.getEpisodes(podcastKey, params, isAiPodcast)

    if (!isStale?.()) {
      commit("setEpisodes", result.data)
    }

    return result
  } catch (e) {
    console.error(e)

    if (!silent && !isStale?.()) {
      await notificationError("Unable to load episodes. Please try again.", "Failed to load episodes")
    }

    throw e
  }
}

export const getEpisode = async ({ commit, rootGetters }, { podcastKey, episodeKey, isAiPodcast }) => {
  try {
    const isAi = resolveIsAiPodcast({ isAiPodcast }, rootGetters)
    const episode = await EpisodeService.getEpisode(podcastKey, episodeKey, isAi)
    commit("setEpisode", episode)
    return episode
  } catch (e) {
    console.error(e)
    await notificationError("Unable to load episode. Please try again.", "Failed to load episode")
    throw e
  }
}

export const createEpisode = async (context, { podcastKey, episode }) => {
  try {
    return await EpisodeService.createEpisode(podcastKey, episode)
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const updateEpisode = async ({ commit, rootGetters }, data) => {
  try {
    const isAiPodcast = resolveIsAiPodcast(data, rootGetters)
    const episode = await EpisodeService.updateEpisode(data, isAiPodcast)
    commit("setEpisode", episode)
    return episode
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const deleteEpisodes = async ({ dispatch, rootGetters }, { podcastKey, episodeKeys, isAiPodcast }) => {
  const isAi = resolveIsAiPodcast({ isAiPodcast }, rootGetters)
  const keys = []

  for (const episodeKey of episodeKeys) {
    if (rootGetters["EpisodeUploads/uploadFor"](episodeKey)) {
      await dispatch("EpisodeUploads/discardEpisode", { podcastKey, episodeKey, isAiPodcast: isAi }, { root: true })
    } else {
      keys.push(episodeKey)
    }
  }

  if (!keys.length) return

  try {
    await EpisodeService.deleteEpisodes(podcastKey, keys, isAi)
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const deleteEpisode = async ({ dispatch, rootGetters }, { podcastKey, episodeKey, isAiPodcast }) => {
  const isAi = resolveIsAiPodcast({ isAiPodcast }, rootGetters)

  if (rootGetters["EpisodeUploads/uploadFor"](episodeKey)) {
    await dispatch("EpisodeUploads/discardEpisode", { podcastKey, episodeKey, isAiPodcast: isAi }, { root: true })
    return
  }

  try {
    await EpisodeService.deleteEpisode(podcastKey, episodeKey, isAi)
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const resetEpisode = ({ commit }) => {
  commit("resetEpisode")
}

// The transcript is stored right away (it is a file, not a form field). Only the transcript fields are returned, so
// the caller can patch its form without replacing unsaved edits.
export const uploadEpisodeTranscript = async (context, { podcastKey, episodeKey, file }) => {
  try {
    const { transcript_url, transcript_type } = await EpisodeService.uploadEpisodeTranscript(
      podcastKey,
      episodeKey,
      file
    )
    return { transcript_url, transcript_type }
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const deleteEpisodeTranscript = async (context, { podcastKey, episodeKey }) => {
  try {
    await EpisodeService.deleteEpisodeTranscript(podcastKey, episodeKey)
    return { transcript_url: null, transcript_type: null }
  } catch (e) {
    console.error(e)
    throw e
  }
}
